import { Pipe, PipeTransform } from '@angular/core';

import {
  EnumLocalizationHelper,
  EnumTypeName,
  LocalizableEnumType,
} from '../helpers/enum-localization.helper';

/**
 * Pipe for localizing enum values.
 * Transforms an enum value to its localized string representation.
 *
 * @example
 * ```html
 * <span>{{ employeeStatus | localizedEnum: 'EmployeeStatusEnum' }}</span>
 * <span>{{ salaryType | localizedEnum: 'SalaryTypeV3EnumDto' }}</span>
 * ```
 */
@Pipe({
  name: 'localizedEnum',
  standalone: true,
})
export class LocalizedEnumPipe implements PipeTransform {
  /**
   * Transforms an enum value to its localized string.
   * @param value - The enum value to localize
   * @param enumType - The type name of the enum (method name without 'get' prefix)
   * @returns The localized string for the enum value
   */
  transform(value: LocalizableEnumType, enumType: EnumTypeName): string {
    const translatorFnName = `get${enumType}` as keyof typeof EnumLocalizationHelper;
    const translatorFn = EnumLocalizationHelper[translatorFnName];

    if (translatorFn && typeof translatorFn === 'function') {
      return (translatorFn as (val: LocalizableEnumType) => string)(value);
    } else {
      console.warn(`No localization method found: EnumLocalizationHelper.${translatorFnName}`);
      return String(value ?? '');
    }
  }
}
